import { useCallback } from 'react'
import {
  useCreateMediaObjects,
  useCreateMediaObjectsWithProgress,
} from 'hooks/queries/mediaObjects/useCreateMediaObjects'

export const useFileUpload = () => {
  const { mutateAsync: createMediaObjects, isLoading: isLoadingMediaObjects } = useCreateMediaObjects()

  const handleUpload = useCallback(
    async (files: File[]) => {
      if (!files.length) return

      const mediaObjects = await createMediaObjects(files.map((file) => ({ file, filename: file.name })))

      return mediaObjects
    },
    [createMediaObjects],
  )

  return {
    handleUpload,
    isLoading: isLoadingMediaObjects,
  }
}

export const useFileUploadWithProgress = ({ onProgress }: { onProgress: (progress: number) => void }) => {
  const { mutateAsync: createMediaObjectsWithProgress, isLoading: isLoadingMediaObjects } =
    useCreateMediaObjectsWithProgress({
      onProgress,
    })

  const handleUpload = useCallback(
    async (files: File[]) => {
      if (!files.length) return

      const mediaObjects = await createMediaObjectsWithProgress(files.map((file) => ({ file, filename: file.name })))

      return mediaObjects
    },
    [createMediaObjectsWithProgress],
  )

  return {
    handleUpload,
    isLoading: isLoadingMediaObjects,
  }
}
